import request from '../request'

export default {
  indexData(parameter) {
    return request({
      url: 'statistics/tongji',
      method: 'post',
      data: parameter,
    })
  },
  indexDataNew(parameter) {
    return request({
      url: 'statistics/new-tongji',
      method: 'post',
      data: parameter,
    })
  },
  provinceData(parameter) {
    return request({
      url: 'statistics/city-stamina-test',
      method: 'post',
      data: parameter,
    })
  },
  yundongData(parameter) {
    return request({
      url: 'statistics/city-motion',
      method: 'post',
      data: parameter,
    })
  },
  stadiumList(parameter) {
    return request({
      url: 'statistics/stadium-list',
      method: 'post',
      data: parameter,
    })
  },
  dayWeekMonth(parameter) {
    return request({
      url: 'statistics/day-week-month',
      method: 'post',
      data: parameter,
    })
  },
  cMap(parameter) {
    return request({
      url: 'statistics/cmap',
      method: 'post',
      data: parameter,
    })
  },
}